// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';
import { isMobileOnly } from 'react-device-detect';
import { Link } from 'react-router-dom';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Prime react imports
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';

// Styling
import './trainings-public.scss';

// Redux
import { connect } from 'react-redux';
import TrainingService from '../../redux/services/training';
import { updateBasket } from '../../redux/actions/order';

// Utils
import { TRAINING_AREA_CONGRESS } from '../../common/constants';
import { getPrettyDatetime } from '../../common/utils/date-utils';

class PublicTrainingsPage extends Component {

    constructor(props) {    
        super(props);
        this._toast = React.createRef();
        this.state = {
            selectedTraining: null,
            trainings: []
        };
    }

    componentDidMount() {
        TrainingService.getPublicTrainings()
        .then((response) => {
            let trainings = [];

            for (let i = 0; i < response.trainings.length; i++) {
                // Filter trainings only
                if(response.trainings[i].trainingAreaId !== TRAINING_AREA_CONGRESS) {
                    trainings.push(response.trainings[i]);
                }
            }

            this.setState({
                trainings: trainings
            });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("trainings.messages.error"), life: 3000 });
        });
    }

    checkTrainingAvailability(trainingRef) {
        if(this.props.basketTrainings !== undefined) {
            for (let i = 0; i < this.props.basketTrainings.length; i++) {
                if(this.props.basketTrainings[i].trainingRef === trainingRef) {
                    return false;
                }            
            }   
        }

        return true;
    }

    submitAcquisition(training) {
        let trainings = [];

        for (let i = 0; i < this.props.basketTrainings.length; i++) {
            trainings.push(this.props.basketTrainings[i]);
        }

        trainings.push({
            trainingRef: training.trainingRef,
            title: training.title,
            price: training.price,
            invoiceItem: training.invoiceItem
        });

        this.props.updateBasket(this.props.basketProducts, trainings);

        this.addTrainingToBasketCallback();
    }
    
    addTrainingToBasketCallback() {
        this.setState({
            selectedTraining: null
        });

        window.scrollTo(0, 0);
        window.open(process.env.PUBLIC_URL + "/checkout", "_self")
        this._toast.current.show({ severity: 'success', detail: this.props.t("products.messages.product-added"), life: 3000 });
    }

    getTrainingSubtitleData(training) {
        return <div className="grid mgt-20">
                    <div className="col-12 t-align-left">
                        <i className="pi pi-globe mgr-10" style={{fontSize:"1.2rem"}}></i>
                        <span style={{fontSize:"1.2rem"}}>{training.place}</span>
                    </div>
                    <div className="col-12 t-align-left">
                        <i className="pi pi-calendar mgr-10" style={{fontSize:"1.2rem"}}></i>
                        <span style={{fontSize:"1.2rem"}}>{getPrettyDatetime(training.trainingStartDate)}</span>
                    </div>
                    <div className="col-12 t-align-left">
                        <i className="pi pi-stopwatch mgr-10" style={{fontSize:"1.2rem"}}></i>
                        <span style={{fontSize:"1.2rem"}}>{this.props.t("trainings.labels.duration")} {training.duration.totalHours}</span>
                    </div>
                </div>;
    }

    selectTraining(training) {
        this.setState({selectedTraining: training});
    }

    render() {
       return (
            <div>
                <div>
                {
                    localStorage.getItem('Hideinapp') === "1" ?
                        <div className="grid" style={{minHeight:"60px", alignItems:"center", background: "#0073AA", textAlign: "left"}}>
                            <div className="col-1"></div>
                            <div className="col-6">
                                <span style={{color:"#FFFFFF", fontSize:"18px"}}>{this.props.t("trainings.title")}</span>
                            </div>
                            <div className="col-4 t-align-right" style={{paddingRight: "20px"}}>
                                <Link to={process.env.PUBLIC_URL + "/checkout"}>
                                    {
                                        this.props.basketProducts.length === 0 ?
                                            <i className="pi pi-shopping-cart c-pointer" style={{ color: "#ffffff", fontSize: '1.9rem' }} title={this.props.t("checkout.menu")}></i>
                                            :
                                            <i className="pi pi-shopping-cart p-overlay-badge c-pointer" style={{ color: "#ffffff", fontSize: '1.9rem' }} title={this.props.t("checkout.menu")}>
                                                <Badge style={{ borderColor: "#ffffff" }} value={this.props.basketTrainings.length}></Badge>
                                            </i>
                                    }
                                </Link>
                            </div>
                            <div className="col-1"></div>
                        </div>
                        :
                        <PageTitleComponent title={this.props.t("trainings.title")} />
                }
        </div>
        <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
            <div className='col-1'></div>
            <div className="col-10"> 
                <div className='grid container mgt-20'>
                    { 
                        this.state.trainings.map((training) => {
                            return (
                                    <div key={training.trainingRef} className="col-12 md:col-12 lg:col-3">
                                        <Card style={{color: "#0073aa", display: "flex", flexWrap: "wrap", alignContent: "space-between", flexDirection: "column", minHeight: "250px"}} 
                                            title={training.title} 
                                            subTitle={this.getTrainingSubtitleData(training)} 
                                            footer={ <div className='grid'>
                                                            <div style={{paddingTop: "15px"}} className='col-5 t-align-left'>
                                                                <b style={{fontSize: "16px", marginTop: "10px", marginLeft: "10px"}}>{training.price === null ? this.props.t("trainings.labels.free") : training.price + "€"}</b>
                                                            </div>
                                                            <div className='col-7 t-align-right'>
                                                                <div className="flex flex-wrap justify-content-end gap-2">
                                                                    <Button label={this.props.t("products.labels.add")} icon="pi pi-shopping-cart" disabled={!this.checkTrainingAvailability(training.trainingRef)} onClick={(evt) => this.selectTraining(training)} />
                                                                </div>
                                                            </div>
                                                        </div>} 
                                            header={<img alt="Card" src={"data:image/jpeg;base64," + training.cardImg} />} 
                                            className="md:w-25rem">
                                        </Card>
                                    </div>
                            );
                        })
                    }
                </div>  
                <div className='grid container mgt-20'>
                {
                    this.state.trainings.length > 0 ? 
                        <div className="col-12 md:col-12 lg:col-12 t-align-center">
                            { /* <Button className='p-button-success' style={{fontSize: "20px"}} label={this.props.t("checkout.messages.close-registration")} onClick={() => window.open(process.env.PUBLIC_URL + "/checkout", "_self")}  /> */ }
                        </div>
                        : 
                        <div className="col-12 md:col-12 lg:col-12 t-align-center">
                            <p style={{fontSize:"14px"}}>{this.props.t("trainings.messages.no-trainings")}</p>
                        </div>
                }
                </div>
            </div>
            <div className='col-1'></div>
        </div>
        <Dialog visible={this.state.selectedTraining !== null} style={{ width: '120vh' }} header={this.state.selectedTraining !== null ? this.state.selectedTraining.title + " - " + this.state.selectedTraining.content[0] : ""} modal onHide={() => this.setState({selectedTraining: null}) }>
            { /* <PublicCongressComponent training={this.state.selectedTraining} onClose={() => this.addTrainingToBasketCallback() } /> */ }
        </Dialog>
        <Toast position='bottom-left' ref={this._toast} />
    </div>
);
    }
}

const mapStateToProps = (state) => {
    return {
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(PublicTrainingsPage));